export default __webpack_public_path__ + "font-selection-editor.png";